import React from 'react';
import { PageLoading } from '../../../ui-toolkit';
import { useListClientsQuery } from '../../../API/clients/ClientCompanyApi';
import { useListLendersQuery } from '../../../API/lenders/LenderCompanyApi';
import { ErrorMessageTW } from '../../../tailwindComponents/errorMessage/ErrorMessageTW';
import type { FCWithChildren } from '../../../types/FCWithChildren';

// Resets the CreateNewOrderDataSlice
// When in the admin portal, enforces the presence of data about clients and lenders
export const SetupDataWrapper: FCWithChildren<{ clientOrLenderId?: string }> = ({ children, clientOrLenderId }) => {
  const { isFetching: isFetchingClients, error: clientsError } = useListClientsQuery({}, { skip: !!clientOrLenderId });
  const { isFetching: isFetchingLenders, error: lendersError } = useListLendersQuery({}, { skip: !!clientOrLenderId });
  const isFetching = isFetchingClients || isFetchingLenders;
  const clientLenderFetchError = clientsError ?? lendersError;

  return (
    <>
      <ErrorMessageTW rtkError={clientLenderFetchError} />
      <PageLoading isLoading={isFetching}>{children}</PageLoading>
    </>
  );
};
